export function setSafariBottom() {
  const vv = window.visualViewport

  if (!vv) {
    document.documentElement.style.setProperty('--safari-bottom', '0px')
    return
  }

  const bottomOffset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop)

  document.documentElement.style.setProperty('--safari-bottom', `${bottomOffset}px`)
}

document.addEventListener('DOMContentLoaded', function () {
  setSafariBottom()

  window.addEventListener('resize', setSafariBottom)

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setSafariBottom)
    window.visualViewport.addEventListener('scroll', setSafariBottom)
  }
})
